import { LeadData } from './types'

class LeadHelper {
  static STORAGE_KEY = 'lead'

  static setLeadDataLocalStorage = (leadData: LeadData) => {
    return localStorage.setItem(LeadHelper.STORAGE_KEY, JSON.stringify(leadData))
  }

  static getLeadDataLocalStorage = (): LeadData => {
    const leadString = localStorage.getItem(LeadHelper.STORAGE_KEY)
    const leadData = leadString
      ? JSON.parse(leadString)
      : {}

    return {
      email: leadData.email || '',
      name: leadData.name || '',
      schedule: leadData.schedule || '',
      photo: leadData.photo || '',
      accepted: Boolean(leadData.accepted),
      userPlatformId: leadData.userPlatformId || 0
    }
  }
}

export default LeadHelper
